import {
  IJobRole,
  IRecommendedQuestion,
  IDeleteEvaluationCriteriaAPIPayload,
  IAddEvaluationCriteriaAPIPayload,
  IDeleteRecommendedQuestionAPI,
  IUploadJobDescriptionAPIPayload,
} from '../../types/Interviews/jobRole.types';
import { ISearchQuery } from '../../types/Interviews/jobRoles.types';
import { HTTP_METHODS } from '../../constants/HttpConstants';
import { sendRequestToServerWithCredentials } from '../../utils/request';
import { ICreateJobRole } from '../../types/utils.types';

export const getAllInterviewsApi = (params: ISearchQuery) =>
  sendRequestToServerWithCredentials({
    method: HTTP_METHODS.GET,
    url: '/search/role/',
    params: params,
    paramsSerializer: (queryParams) => {
      return Object.entries(queryParams)
        .map((queryParam) => {
          const [paramKey, paramValue] = queryParam;
          if (
            (!paramValue && paramValue !== 0) ||
            (typeof paramValue === 'object' && !paramValue.length)
          )
            return null;
          else if (typeof paramValue === 'object' && paramValue.length) {
            return paramValue
              .map((value: any) => [paramKey, value].join('='))
              .join('&');
          }
          return queryParam.join('=');
        })
        .filter((data) => data)
        .join('&');
    },
  });

export const getHiringRolesApi = () =>
  sendRequestToServerWithCredentials({
    method: HTTP_METHODS.GET,
    url: '/search/hiring_role/?limit=1000',
  });

export const createJobRoleApi = (payload: ICreateJobRole) => {
  return sendRequestToServerWithCredentials({
    method: HTTP_METHODS.POST,
    url: `/roles/`,
    data: payload,
    headers: { 'Content-Type': 'application/json' },
  });
};

export const updateJobRoleApi = (jobRoleSlug: string, payload: IJobRole) => {
  return sendRequestToServerWithCredentials({
    method: HTTP_METHODS.PUT,
    url: `/roles/${jobRoleSlug}/`,
    data: payload,
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadJobDescriptionApi = (
  jobRoleSlug: string,
  payload: IUploadJobDescriptionAPIPayload
) => {
  return sendRequestToServerWithCredentials({
    method: HTTP_METHODS.POST,
    url: `roles/${jobRoleSlug}/upload_jd/`,
    data: payload,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const archiveJobRoleApi = (jobRole: string) => {
  return sendRequestToServerWithCredentials({
    method: HTTP_METHODS.POST,
    url: `/roles/${jobRole}/archive/`,
  });
};

export const cloneJobRoleApi = (jobRole: string) => {
  return sendRequestToServerWithCredentials({
    method: HTTP_METHODS.POST,
    url: `/roles/${jobRole}/clone/`,
  });
};

export const getSingleJobRoleApi = (slug: string) => {
  return sendRequestToServerWithCredentials({
    method: HTTP_METHODS.GET,
    url: `/roles/${slug}/`,
  });
};

export const deleteRecommendedQuestionApi = ({
  jobRoleSlug,
  questionSlug,
}: IDeleteRecommendedQuestionAPI) => {
  return sendRequestToServerWithCredentials({
    method: HTTP_METHODS.DELETE,
    url: `/roles/${jobRoleSlug}/recommend/${questionSlug}/`,
  });
};

export const addRecommendedQuestionApi = ({
  body,
  slug,
}: {
  body: IRecommendedQuestion;
  slug: string;
}) => {
  return sendRequestToServerWithCredentials({
    method: HTTP_METHODS.POST,
    url: `/roles/${slug}/recommend/`,
    data: body,
  });
};

export const deleteEvaluationCriteriaApi = ({
  jobRoleSlug,
  criteriaSlug,
}: IDeleteEvaluationCriteriaAPIPayload) => {
  return sendRequestToServerWithCredentials({
    method: HTTP_METHODS.DELETE,
    url: `/roles/${jobRoleSlug}/criteria/${criteriaSlug}/`,
  });
};

export const resetEvaluationCriteriaApi = (jobRoleSlug: string) => {
  return sendRequestToServerWithCredentials({
    method: HTTP_METHODS.POST,
    url: `/roles/${jobRoleSlug}/reset_criteria/`,
  });
};

export const addEvaluationCriteriaApi = ({
  jobRoleSlug,
  body,
}: IAddEvaluationCriteriaAPIPayload) => {
  return sendRequestToServerWithCredentials({
    method: HTTP_METHODS.POST,
    url: `/roles/${jobRoleSlug}/criteria/`,
    data: body,
  });
};
